export default "__VITE_ASSET__1a8d262f__"